import Vue from "vue";

// Lightweight global event bus used to bridge logic in mixins/helpers with
// globally-mounted UI components (e.g. the void reason modal in App.vue).
export const EventBus = new Vue();

export default EventBus;
